import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  useFeaturedMentors,
  useHomepageData,
} from '../../hooks/apiHooks/MentorHooks'
import { useMentorsState } from '../../hooks/storeHooks/useMentors'
import { MentorBase } from '../../types/mentor'
import { reorganizeMentors } from '../../utils/reorganizeMentors'
import { splitToChunks } from '../../utils/splitToChunks'

export const useMentors = (slug?: string) => {
  const memoizedSlug = useRef(slug)

  const {
    featuredMentorPage,
    featuredMentors,
    featuredMentorsChunks,
    setFeaturedMentorsChunks,
    setFeaturedMentorPage,
    setFeaturedMentors,
  } = useMentorsState()

  const navigate = useNavigate()

  const { data } = useHomepageData(!featuredMentors.length)
  const { data: featuredMentorsData } = useFeaturedMentors(
    !featuredMentors.length,
  )

  useEffect(() => {
    if (
      !featuredMentorsChunks &&
      data?.data?.searchMentors?.collection?.length &&
      featuredMentorsData?.length
    ) {
      let selectedMentor = null

      if (memoizedSlug.current) {
        selectedMentor =
          featuredMentorsData.find(
            (mentor: MentorBase) => mentor.slug === memoizedSlug.current,
          ) ||
          data.data.searchMentors.collection.find(
            (mentor: MentorBase) => mentor.slug === memoizedSlug.current,
          )
        if (!selectedMentor && featuredMentorsData.length > 0) {
          navigate('/not-found')
        }
      }
      const chunks = splitToChunks(
        reorganizeMentors(
          data.data.searchMentors.collection,
          featuredMentorsData,
          selectedMentor,
        ),
      )
      setFeaturedMentorsChunks(chunks)
      setFeaturedMentors(chunks[0])
    }
  }, [
    data?.data?.searchMentors?.collection,
    featuredMentorsData,
    featuredMentorsChunks,
    setFeaturedMentorsChunks,
    setFeaturedMentors,
  ])

  const setNextPage = () => {
    if (
      featuredMentorsChunks &&
      featuredMentorPage <= (featuredMentorsChunks?.length ?? 0) - 1
    ) {
      const page = featuredMentorPage + 1
      if (featuredMentorsChunks[page]) {
        setFeaturedMentorPage(page)
        setFeaturedMentors(featuredMentorsChunks[page])
      }
    }
  }

  return {
    setNextPage,
    mentors: featuredMentors,
    hasNextChunk:
      featuredMentorPage <= (featuredMentorsChunks?.length || 1) - 1,
  }
}
